var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-custom"},[_c('Breadscrumbs',{attrs:{"links":[
      { name: 'QuikTip', to: { path: '/quiktips' } },
      { name: 'Create', to: { path: '/quiktips/create' } } ]}}),_c('div',{staticClass:"page-actions"},[_c('h2',[_vm._v("新增 Quiktips")]),_c('v-spacer')],1),_c('QuiktipsCreateEdit')],1)}
var staticRenderFns = []

export { render, staticRenderFns }